import * as React from 'react';
import Form from 'react-bootstrap/Form';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import TimePicker from 'react-bootstrap-time-picker';
import { Col } from 'react-bootstrap';

export interface IAuditLogFilterControlProps {
  logtypename: string;
  datatype: string;
  logpropertyname: string;
  filterName: string;
  onChange?: (logpropertyname: string, searchQuery: any) => void;
}

const initialState = {
  stringValue: '',
  focusedInput: null,
  startDate: moment().subtract(30, 'days'),
  endDate: moment(),
  startTime: 0,
  endTime:  86340
};
type IAuditLogFilterControlState = Readonly<typeof initialState>;

export default class AuditLogFilterControl extends React.Component<
  IAuditLogFilterControlProps,
  IAuditLogFilterControlState
> {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    if (
      this.props.datatype == 'daterange' &&
      this.state.startDate &&
      this.state.endDate
    ) {
      this.handleDatesChanged(this.state.startDate, this.state.endDate);
    }
  }

  makeStringQuery(): any {
    const query = {
      query_string: {
        default_field: this.props.logpropertyname,
        query: this.state.stringValue,
      },
    };
    return query;
  }

  onChangeTextField(logpropertyname, e: any) {
    this.setState({ stringValue: e.target.value }, () => {
      const searchQuery = this.makeStringQuery();
      this.props.onChange(this.props.logpropertyname, searchQuery);
    });
  }

  

  onChangeTimeFrom(e: any) {
    this.setState({ startTime: e }, () => {
      const searchQuery = this.makeDateQuery();
      this.props.onChange(this.props.logpropertyname, searchQuery);
    });
  }

  onChangeTimeTo(e: any) {
    this.setState({ endTime: e }, () => {
      const searchQuery = this.makeDateQuery();
      this.props.onChange(this.props.logpropertyname, searchQuery);
    });
  }


  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      this.setState({ startDate, endDate }, () => {
        const searchQuery = this.makeDateQuery();
        this.props.onChange(this.props.logpropertyname, searchQuery);
      });
    }
  }

  getHours(seconds: number){
    return Math.floor(seconds / 3600).toString().padStart(2, "0");
  }
  getMinutes(seconds: number){
    return Math.floor((seconds % 3600) / 60).toString().padStart(2, "0");
  }

  makeDateQuery(): any {
    const endTime1 = this.state.endTime == 0 ? 86340 : this.state.endTime;
    const end2 = moment(this.state.endDate).format('YYYY-MM-DD')+"T"+this.getHours(endTime1)
      +":"+this.getMinutes(endTime1)+":00";
    const start2 = moment(this.state.startDate).format('YYYY-MM-DD')+"T"+this.getHours(this.state.startTime)
      +":"+this.getMinutes(this.state.startTime)+":00";
    const end3 = moment(end2).utcOffset(-4);
    const start3 = moment(start2).utcOffset(-4);
    const query = {
      range: {
        [this.props.logpropertyname]: {
          gte: start3, // "2019-07-29T00:00:00Z",
          lte: end3
        },
      },
    };
    return query;
  }


  public render() {
    return (
      <React.Fragment>
        {(() => {
          switch (this.props.datatype) {
            case 'string':
              return (
                <Form.Control
                  type='text'
                  value={this.state.stringValue}
                  onChange={(e) =>
                    this.onChangeTextField(this.props.logpropertyname, e)
                  }
                />
              );
            case 'daterange':
              return (
                <React.Fragment>
                  <Form.Row>
                    <Form.Group as={Col}>
                      <DateRangePicker
                        startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                        startDateId={this.props.logpropertyname + '_start'} // PropTypes.string.isRequired,
                        endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                        endDateId={this.props.logpropertyname + '_end'} // PropTypes.string.isRequired,
                        onDatesChange={({ startDate, endDate }) =>
                          this.handleDatesChanged(startDate, endDate)
                        } // PropTypes.func.isRequired,
                        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                        onFocusChange={(focusedInput) =>
                          this.setState({ focusedInput })
                        } // PropTypes.func.isRequired,
                        isOutsideRange={() => false}
                        small={true}
                        block={false}
                        minimumNights={0}
                      />
                    </Form.Group>
                    <Form.Group key="timething" as={Col}>
                        <TimePicker id="timefrom" key="timefrom" format={24} step={15} value={this.state.startTime} onChange={(e) =>
                          this.onChangeTimeFrom(e)
                        }/>
                        <TimePicker id="timeto" key="timeto" format={24} step={15} value={this.state.endTime} onChange={(e) =>
                          this.onChangeTimeTo(e)
                        }/>
                    </Form.Group>
                </Form.Row>
              </React.Fragment>
              );
            default:
              return 'no matching control for datatype ' + this.props.datatype;
          }
        })()}
      </React.Fragment>
    );
  }
}
